// extracted by mini-css-extract-plugin
module.exports = {"splash":"splash_splash__iBo1q","lottie":"splash_lottie__ejFx4","text":"splash_text__NPxY3","bar":"splash_bar__awCZD","init":"splash_init__iMeIn","hide":"splash_hide__bLSUd"};